// editor-commands.ts — small editor-layer command leaf.
//
// Home for editor mutations that need the NoteEditor surface but don't
// belong in the bootstrap/state layer. Lives here (not in core/app-state.js)
// so app-state stays free of any editor/ import — that edge previously closed
// a core↔editor import cycle (app-state → note-editor → app-state). The
// one-way note-editor → app-state accessor edge is unaffected.

import { NoteEditor } from './note-editor.js';

// ── Insert text at the cursor (and dispatch a change so listeners fire) ───
// Inserts `text` as its own block: prepends a newline when the caret isn't
// already at column 0, and appends a trailing newline, then moves the caret
// past the inserted block. Used by the attachment funnel (paste/drop/picker).
/** `text` is inserted as its own block at the caret. */
export function insertAtCursor(text: string): void {
  const sel = NoteEditor.getSelection();
  const start = Math.min(sel.anchor, sel.head);
  const end = Math.max(sel.anchor, sel.head);
  const value = NoteEditor.getContent();
  const before = value.substring(0, start);
  const nl = before.length > 0 && !before.endsWith('\n') ? '\n' : '';
  const insert = `${nl + text}\n`;
  const pos = start + insert.length;
  NoteEditor.dispatchChange({ from: start, to: end, insert }, pos);
  NoteEditor.focus();
}
